module.exports = __webpack_public_path__ + "static/media/malt-syrup-thumb.ed864857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/malt-syrup-thumb.jpg
// module id = 580
// module chunks = 0